import { render, staticRenderFns } from "./RtcGroupJoin.vue?vue&type=template&id=9f63948e&scoped=true"
import script from "./RtcGroupJoin.vue?vue&type=script&lang=js"
export * from "./RtcGroupJoin.vue?vue&type=script&lang=js"
import style0 from "./RtcGroupJoin.vue?vue&type=style&index=0&id=9f63948e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f63948e",
  null
  
)

export default component.exports